export default __webpack_public_path__ + "static/media/employer-paternity-leave-policy.8caefc64.pdf";